import { Component, ChangeDetectorRef } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { SentryBreadcrumbsService } from '@app/core/services/sentry-breadcrumbs.service';
import { GmailGenerateOtpComponent } from '../../common/gmail-generate-otp/gmail-generate-otp.component';
import { MainChangeNumberComponent } from '../../common/main-change-number/main-change-number.component';
import { MainForgotPasswordComponent } from '../../common/main-forgot-password/main-forgot-password.component';
import { MainOtpVerificationComponent } from '../../common/main-otp-verification/main-otp-verification.component';
import { MobileLoginWithPasswordComponent } from '../mobile-login-with-password/mobile-login-with-password.component';
import { MainSignupComponent } from '../../common/main-signup/main-signup.component';
import { MobileNumberComponent } from '../../desktop-components/mobile-number/mobile-number.component';

@Component({
    selector: 'app-mobile-login-wrapper',
    templateUrl: './mobile-login-wrapper.component.html',
    styleUrls: ['./mobile-login-wrapper.component.scss'],
    standalone: true,
    imports: [MobileNumberComponent, MainSignupComponent, MobileLoginWithPasswordComponent, MainOtpVerificationComponent, MainForgotPasswordComponent, MainChangeNumberComponent, GmailGenerateOtpComponent]
})
export class MobileLoginWrapperComponent {
    step: string;

    constructor(
        public bottomSheetRef: MatBottomSheetRef<MobileLoginWrapperComponent>,
        private authenticationService: AuthenticationService,
        private changeDetectorRef: ChangeDetectorRef,
        private breadCrumb: SentryBreadcrumbsService
    ) {
        this.authenticationService.mobileStep.subscribe(data => {
            this.step = data;
            this.changeDetectorRef.markForCheck();

            this.breadCrumb.add('auth', 'step: ' + data, null);
        });

        // data : { authentication:  Boolean}
        this.authenticationService.closeWrapperDialog.subscribe(data => {
            this.breadCrumb.add('auth', 'closeWrapperDialog Called', null);
            this.bottomSheetRef.dismiss(data);
        });

        this.breadCrumb.add('auth', 'Constructor MobileLoginWrapperComponent', null);
    }

    // Used to Close Dialog in both Success & Failure cases
    close(event: { authentication: boolean } = { authentication: false }) {
        this.breadCrumb.add('auth', 'closes bottom sheet Called', null);
        this.bottomSheetRef.dismiss(event);
    }
}
